import { jsxs as o, jsx as s } from "react/jsx-runtime";
import m from "next/link";
import e from "clsx";
import { ArrowRightIcon as r } from "../../icons/ArrowRightIcon.js";
import { getStylesFromSelectors as p, createPureSelectors as x } from "../../utils/classNameSelectors.js";
import "../../utils/sectionPreview.js";
import "react";
import '../../_assets/CardInfoLink.1tOhl9nd.css';const d = "_link_cnlbb_86", a = "_wrap_cnlbb_94", k = "_icon_cnlbb_112", f = "_arrow_cnlbb_113", h = "_info_cnlbb_118", w = "_title_cnlbb_125", u = "_text_cnlbb_129", l = {
  link: d,
  wrap: a,
  icon: k,
  arrow: f,
  info: h,
  title: w,
  text: u,
  "xxs-mobile": "_xxs-mobile_cnlbb_134",
  "xxs-desktop": "_xxs-desktop_cnlbb_183",
  "xs-mobile": "_xs-mobile_cnlbb_234",
  "xs-desktop": "_xs-desktop_cnlbb_283",
  "s-mobile": "_s-mobile_cnlbb_334",
  "s-desktop": "_s-desktop_cnlbb_383",
  "ssm-mobile": "_ssm-mobile_cnlbb_434",
  "ssm-desktop": "_ssm-desktop_cnlbb_483",
  "sm-mobile": "_sm-mobile_cnlbb_534",
  "sm-desktop": "_sm-desktop_cnlbb_583",
  "m-mobile": "_m-mobile_cnlbb_634",
  "m-desktop": "_m-desktop_cnlbb_683",
  "xm-mobile": "_xm-mobile_cnlbb_734",
  "xm-desktop": "_xm-desktop_cnlbb_783",
  "l-mobile": "_l-mobile_cnlbb_834",
  "l-desktop": "_l-desktop_cnlbb_883",
  "xl-mobile": "_xl-mobile_cnlbb_934",
  "xl-desktop": "_xl-desktop_cnlbb_983",
  "xxl-mobile": "_xxl-mobile_cnlbb_1034",
  "xxl-desktop": "_xxl-desktop_cnlbb_1083",
  "slide-in-out": "_slide-in-out_cnlbb_1",
  "fade-in-out": "_fade-in-out_cnlbb_1"
}, A = ({
  title: _,
  text: b,
  path: t,
  icon: n,
  variant: i = "mobile"
}) => {
  const c = p(x(i, "mobile"), l);
  return /* @__PURE__ */ o(m, { href: t, passHref: !0, className: e(l.link, c), children: [
    /* @__PURE__ */ o("div", { className: l.wrap, children: [
      /* @__PURE__ */ s("span", { className: l.icon, children: n }),
      /* @__PURE__ */ o("div", { className: l.info, children: [
        /* @__PURE__ */ s("h6", { className: l.title, children: _ }),
        /* @__PURE__ */ s("p", { className: l.text, children: b })
      ] })
    ] }),
    /* @__PURE__ */ s("span", { className: e(l.arrow), children: /* @__PURE__ */ s(r, { titleAccess: "arrow right", size: 32 }) })
  ] });
};
export {
  A as CardInfoLink
};
